import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

/**
 * Interceptor to ensure all API requests include credentials (HttpOnly cookies)
 * and handle 401 errors for token refresh scenarios.
 * 
 * This interceptor replaces the MSAL Authorization header approach with HttpOnly cookies.
 * The backend validates tokens from cookies instead of the Authorization header,
 * ensuring tokens are never exposed to JavaScript.
 * 
 * SECURITY: Tokens in sessionStorage (MSAL) are NOT sent to backend.
 * Only HttpOnly cookies (set by backend) are used for authentication.
 */
@Injectable()
export class SecureAuthInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Add withCredentials to ALL API requests to send HttpOnly cookies
    // Backend will validate tokens from cookies instead of Authorization header
    const isApiRequest = request.url.includes('/api/');
    
    const secureRequest = isApiRequest
      ? request.clone({ withCredentials: true })
      : request;

    return next.handle(secureRequest).pipe(
      catchError((error: HttpErrorResponse) => {
        // Don't call checkAuthStatus - it creates an infinite loop
        // Just pass the error through and let the app handle it
        return throwError(() => error);
      })
    );
  }
}
